"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = exports.Customize = void 0;
var react_1 = __importDefault(require("react"));
var Customize_1 = require("./Customize");
Object.defineProperty(exports, "Customize", { enumerable: true, get: function () { return Customize_1.Customize; } });
var Notation_1 = require("./Notation");
var SubSection_1 = require("./SubSection");
var Section = function (_a) {
    var examples = _a.examples, id = _a.id, notation = _a.notation, title = _a.title;
    return (react_1.default.createElement("section", { id: id },
        react_1.default.createElement("p", { className: "f6 mt5 mb3" }, title),
        notation === undefined ? undefined : react_1.default.createElement(Notation_1.Notation, __assign({}, notation)),
        examples === undefined ? undefined : (react_1.default.createElement(SubSection_1.SubSection, { title: "Examples" }, examples))));
};
exports.Section = Section;
